import React, {PropTypes} from 'react';
import _ from 'lodash';

// components
import TextArea from '../../../../../common/components/c_TextArea';

export default class WorkObjectives extends React.Component {
  static propTypes = {
    staticData: PropTypes.object,
    applicant: PropTypes.object,
    defaultValue: PropTypes.object,
    workObjectives: PropTypes.object,
    script: PropTypes.bool,
    tempState: PropTypes.object,
    model: PropTypes.string.isRequired,
    saveData: PropTypes.func,
    errorUpdate: PropTypes.func,
    validator: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = { values: {} };
  }


  onBlur = (prop, qid, event) => {
    this.props.saveData({ [this.props.model]: _.set({}, `${qid}.${prop}`, event.target.value) });
  }

  handleChange = (questionId, e) => {
    const values = _.assign({}, this.state.values);
    values[questionId] = e.target.value;
    this.setState({ values });
  }

  handleTextAreaUI = (listItem, prop) => {
    const newLine = /\\n/g;
    const workObjectives = this.props.workObjectives;
    let value = _.get(this.state, `values[${listItem.id}]`);

    if (_.isUndefined(value)) {
      value = _.get(workObjectives[listItem.id], prop, '');
    }

    return {
      // needed to replace '\n' with actual newline
      value: value.replace(newLine, '\n'),
      onChange: this.handleChange.bind(this, listItem.id),
      onBlur: this.onBlur.bind(this, prop, listItem.id),
      validator: this.props.validator.bind(this, listItem),
      onErrorChange: this.props.errorUpdate,
      showCharacterCount: true,
      maxLength: 4000
    };
  }

  render() {
    // booleans
    const script = this.props.script;
    const workObjectiveQuestions = this.props.staticData.workObjectiveQuestions;

    return (
      <div className='expanded-accordion-content explanation-of-wahve'
        key={`work-objectives ${this.props.applicant.profile.id}`}>
        {
          script
          &&
          <div className='speaking-callout'>
            Now I would like to ask you a few questions about your work objectives.
          </div>
        }
        <div data-id='Questions' className='work-objective-questions'>
          <div className='title'><b>Questions:</b></div>
          <ul className='instructions-list' style={{paddingBottom: !script ? '15px' : null}}>
            {
              workObjectiveQuestions.map((listItem, questionKey) =>
                <li
                  className='instructions-list-item'
                  key={questionKey}
                >
                  <div className='instructions-list-text'>
                    {listItem.question}
                  </div>
                  <TextArea data-id={listItem.id}
                            className='instructions-text-field'
                            {...this.handleTextAreaUI(listItem, 'answer')}
                  />
                </li>
              )
            }
          </ul>
        </div>
        <div className='thanks'>{`Great, Thanks. Let's move on to your home office setup.`}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_WorkObjectives/index.js